var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHasLighting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.5a6 6 0 00-12 0 5.996 5.996 0 004.5 5.803V18.5h3v-1.197a5.998 5.998 0 004.5-5.803zm-5.5 11h-1m2-2h-3m1.5-19v2m10 8h-2m-18 0h2m.221-7.778l2.122 2.122m13.434-2.122l-2.123 2.122",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
export default SvgHasLighting;